import { POST, postFile, GET } from "../../index";

export const getJurisdictionCompany = (param) => POST("/v1/jurisdictionCompany/getJurisdictionCompany", param);
export const addJurisdictionCompany = (param) => POST("/v1/jurisdictionCompany/addJurisdictionCompany", param);
export const deleteJurisdictionCompany = (param) => POST("/v1/jurisdictionCompany/deleteJurisdictionCompany", param);
export const uploadJurisdictionCompany = (param) => postFile("/v1/getExportExcel/uploadJurisdictionCompany", param);

export const getJurisdictionCar = (param) => POST("/v1/jurisdictionCar/getJurisdictionCar", param);
export const getJurisdictionDriver = (param) => POST("/v1/jurisdictionDriver/getJurisdictionDriver", param);
